import React from "react";
import { useNavigate } from "react-router-dom";
import { Truck } from "lucide-react";
import useDriverStatus from "../hooks/useDriverStatus";

export const DriverHint = ({ show }) => {
  const navigate = useNavigate();
  const { is_driver } = useDriverStatus();
  if (!show || !is_driver) return null;
  return (
    <button
      onClick={() => navigate("/driver")}
      className="mx-6 mt-4 w-[calc(100%-3rem)] flex items-center gap-3 rounded-2xl border border-violet-400/40 bg-violet-500/10 p-4 text-left hover:bg-violet-500/15 transition-colors"
      data-testid="driver-hint"
    >
      <Truck className="w-5 h-5 text-violet-200 shrink-0" />
      <span className="text-sm">You're set up as a driver. Your assigned deliveries are in <b>My deliveries</b>.</span>
    </button>
  );
};

export default DriverHint;
